import React from 'react';
import { Button, Group } from '@mantine/core';
import FileDown from '../../assets/icons/FileDown';

const ExportButton = ({ onExport, label = "Exportar para planilha" }) => {
  return (
    <Group justify="flex-end" mb="md">
      <Button
        variant="outline"
        color="#295661"
        size="sm"
        leftSection={<FileDown size={16} />}
        onClick={onExport}
        style={{ fontWeight: '500' }}
      >
        {label}
      </Button>
    </Group>
  );
};

export default ExportButton;
